import logo from '../assets/logo.jpeg';

export default function Footer() {
  return (
    <footer style={{ background: '#2D3B2D' }}>
      <div className="container" style={{ padding: '60px 24px 24px' }}>
        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: 40, marginBottom: 48,
        }}>
          {/* Brand */}
          <div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
              <img src={logo} alt="Gramaayam" style={{
                height: 50, borderRadius: '50%', objectFit: 'cover',
                border: '2px solid rgba(181,196,168,0.2)',
              }} />
              <div>
                <div style={{
                  fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 700,
                  color: '#B5C4A8', letterSpacing: 1.5,
                }}>Gramaayam</div>
                <div style={{ fontSize: 10, color: '#6B7F62', letterSpacing: 2 }}>
                  WHERE PURITY BEGINS
                </div>
              </div>
            </div>
            <p style={{
              fontFamily: "'Cormorant Garamond', serif", fontSize: 15,
              color: '#8B9D7F', lineHeight: 1.7,
            }}>
              Bringing the purest organic products from Indian villages directly to your home.
              Every purchase supports rural farming families.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 style={{ fontSize: 14, fontWeight: 600, color: '#B5C4A8', marginBottom: 16, letterSpacing: 1 }}>
              SHOP
            </h4>
            {['Dry Fruits', 'Jaggery', 'Cold-Pressed Oils', 'Spices', 'Wild Honey', 'Gift Boxes'].map((l) => (
              <p key={l} style={{
                fontSize: 14, color: '#7A8B6F', marginBottom: 10,
                cursor: 'pointer', transition: 'color 0.3s',
              }}>{l}</p>
            ))}
          </div>

          {/* Company */}
          <div>
            <h4 style={{ fontSize: 14, fontWeight: 600, color: '#B5C4A8', marginBottom: 16, letterSpacing: 1 }}>
              COMPANY
            </h4>
            {['Our Story', 'Our Farmers', 'Quality Promise', 'Blog', 'Careers', 'Press'].map((l) => (
              <p key={l} style={{ fontSize: 14, color: '#7A8B6F', marginBottom: 10, cursor: 'pointer' }}>{l}</p>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h4 style={{ fontSize: 14, fontWeight: 600, color: '#B5C4A8', marginBottom: 16, letterSpacing: 1 }}>
              REACH US
            </h4>
            <p style={{ fontSize: 14, color: '#7A8B6F', marginBottom: 12 }}>📧 hello@gramaayam.com</p>
            <p style={{ fontSize: 14, color: '#7A8B6F', marginBottom: 12 }}>📞 +91 98765 43210</p>
            <p style={{ fontSize: 14, color: '#7A8B6F', marginBottom: 12 }}>📍 Varanasi, Uttar Pradesh, India</p>
            <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
              {['Instagram', 'Facebook', 'WhatsApp'].map((s) => (
                <span key={s} style={{
                  fontSize: 12, color: '#A8B89C', padding: '6px 14px',
                  border: '1px solid rgba(181,196,168,0.2)', borderRadius: 20,
                  cursor: 'pointer', transition: 'all 0.3s',
                }}>{s}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid rgba(181,196,168,0.12)',
          padding: '20px 0 0', textAlign: 'center',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 12,
        }}>
          <p style={{ fontSize: 12, color: '#5A6B5A', letterSpacing: 0.5 }}>
            © 2026 Gramaayam — From Village to You. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: 20 }}>
            {['Privacy Policy', 'Terms', 'Refund Policy'].map((l) => (
              <span key={l} style={{ fontSize: 12, color: '#5A6B5A', cursor: 'pointer' }}>{l}</span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
